import {backUser} from "@/lib/api/axios";

export const chatApi = [
    {url: `${backUser}/chat/get-token`, name: 'chat.token', method: 'POST'},
    {url: `${backUser}/chat/{id}/messages`, name: 'chat.messages', method: 'GET'},
    {url: `${backUser}/chat/send`, name: 'chat.send', method: 'POST'},
    {url: `${backUser}/chat/download-file/{file_id}`, name: 'chat.download', method: 'GET'},
]